import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import DashboardLayout from './DashboardLayout';
import RetailerLayout from './RetailerLayout';
import PartnerLayout from './PartnerLayout';

/**
 * Wrapper qui choisit automatiquement le bon layout selon le rôle utilisateur
 * Protège les routes en vérifiant l'authentification
 */
const DashboardWrapper = ({ children }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  
  // Protection : Si pas d'utilisateur connecté, redirection vers login
  useEffect(() => {
    if (!user) {
      navigate('/login', { replace: true });
    }
  }, [user, navigate]);
  
  // Si pas d'utilisateur, ne rien afficher (redirection en cours)
  if (!user) {
    return null;
  }
  
  // Admin : DashboardLayout avec menu admin complet
  if (user.role === 'admin') {
    return <DashboardLayout>{children}</DashboardLayout>;
  }
  
  // Retailer : RetailerLayout avec menu dynamique depuis /api/menu
  if (user.role === 'retailer') {
    return <RetailerLayout>{children}</RetailerLayout>;
  }
  
  // Partenaire : PartnerLayout avec menu simplifié
  if (user.role === 'partenaire') {
    return <PartnerLayout>{children}</PartnerLayout>;
  }
  
  // Rôle inconnu : redirection vers login
  return <Navigate to="/login" replace />;
};

export default DashboardWrapper;
